import HistoryData from "./HistoryData";
export default HistoryData;
